import "./ImagePicker.css";
import ImgPreview from "./ImgPreview";

interface IProps {
	onSelect: (e: any) => void;
	height?: number;
	selected?: string;
	onDelete?: () => void;
	allowEdit?: boolean;
	loading?: boolean;
}

const ImgPicker = (props: IProps) => {
	const {
		onSelect,
		height = 600,
		selected,
		onDelete,
		allowEdit = false,
		loading = false,
	} = props;

	if (selected) {
		return (
			<ImgPreview
				height={height}
				selectedImg={selected}
				onDelete={onDelete}
				allowEdit={allowEdit}
				loading={loading}
			/>
		);
	}
	return (
		<label
			htmlFor="file"
			className={"custum-file-upload"}
			style={{ height: `${height}px`, marginTop: "10px" }}
		>
			<img src="https://placehold.jp/1200x600.png" />
			<input
				onChange={(e) => {
					onSelect(e.target.files ? e.target.files[0] : null);
				}}
				id="file"
				type="file"
				accept="image/*"
			/>
		</label>
	);
};

export default ImgPicker;
